<template>
  <div>
    <v-layout wrap class="form-control">
      <v-flex xs12 sm4 px-2>
        <form class="form-control" :class="{ 'has-error': errors.has('pageId') }">
          <label>รหัสเพจ <span class="red--text">*</span></label>
          <multiselect
            v-model="input.page"
            v-validate="'required'"
            :options="pageOptions"
            select-label
            name="pageId"
            selected-label
            :data-vv-as="'รหัสเพจ'"
            placeholder="รหัสเพจ"
            label="page_id"
            style="margin-bottom: 4px"
            @input="handleSelectedPage"
          ></multiselect>

          <span v-if="errors.has('pageId')" class="text-error">{{ errors.first('pageId') }}</span>
        </form>
      </v-flex>
      <v-flex xs12 sm4 px-2>
        <form class="form-control" :class="{ 'has-error': errors.has('pageName') }">
          <label>ชื่อเพจ <span class="red--text">*</span></label>
          <input
            v-model="input.name"
            v-validate="'required'"
            name="pageName"
            type="text"
            :data-vv-as="'ชื่อเพจ'"
            placeholder="ชื่อเพจ"
          />
          <span v-if="errors.has('pageName')" class="text-error">{{
            errors.first('pageName')
          }}</span>
        </form>
      </v-flex>
      <v-flex xs12 sm4 px-2>
        <form class="form-control" :class="{ 'has-error': errors.has('category') }">
          <label>หมวดหมู่สินค้า <span class="red--text">*</span></label>
          <multiselect
            v-model="input.category"
            v-validate="'required'"
            :options="categoryOptions"
            select-label
            name="category"
            selected-label
            :data-vv-as="'หมวดหมู่สินค้า'"
            placeholder="หมวดหมู่สินค้า"
            label="category_name"
            style="margin-bottom: 4px"
          ></multiselect>
          <span v-if="errors.has('category')" class="text-error">{{
            errors.first('category')
          }}</span>
        </form>
      </v-flex>
      <v-flex xs12 class="text-xs-center">
        <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="handleSave">
          {{ $t('Save') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tcpApi from '@/api/tcp'
import Multiselect from 'vue-multiselect'
import { handleResponse, handleApiError } from '@/api/util'

export default {
  components: {
    Multiselect
  },
  props: ['value', 'type'],
  data() {
    return {
      input: {
        page: '',
        name: '',
        category: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    categoryOptions() {
      let options = []
      // console.log('categories: ', this.categories, 'loadingCategory: ', this.loadingCategory)
      if (this.categories && this.categories.length > 0) {
        options = this.categories.map((category) => {
          return {
            category_id: category.id,
            category_name: category.name
          }
        })
      }
      return options
    },
    pageOptions() {
      return this.$store.state.tcpSubpages
    }
  },
  mounted() {
    if (this.categories.length === 0) {
      this.$store.dispatch('loadCategory')
    }

    if (this.value) {
      this.input.page_id = this.value.page_id
      this.input.name = this.value.name
      const currentCategory = this.categoryOptions.find(
        (item) => item.category_id === this.value.category_id
      )
      this.input.category = currentCategory
    }
  },
  methods: {
    async handleSave() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          return false
        }

        const data = {
          name: vm.input.name,
          category_id: vm.input.category.category_id,
          category_name: vm.input.category.category_name,
          page_id: vm.input.page.page_id
        }

        vm.$store.dispatch('loading')

        let response = null
        if (vm.type === 'add') {
          Object.assign(data, {
            ketshop_api_key: vm.selectedBot.ketshop_api_key,
            ketshop_api_secret: vm.selectedBot.ketshop_api_secret
          })
          response = await vm.createShopPage(data)
        } else {
          response = await vm.updateShopPage(data)
        }
        vm.$store.commit('CLEAR_LOADING')

        if (response && response.status === 200) {
          vm.$emit('onSuccess')
        }
      } catch (error) {
        vm.$store.commit('CLEAR_LOADING')
        console.error(error)
      }
    },
    async createShopPage(payload) {
      try {
        const response = await tcpApi.postCreateShopPage({
          data: payload,
          master_page_id: this.selectedBot.pageid
        })
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    async updateShopPage(payload) {
      try {
        const response = await tcpApi.putUpdateShopPage({
          data: payload,
          master_page_id: this.selectedBot.pageid
        })
        handleResponse(response)

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        handleApiError(error)
        return null
      }
    },
    handleSelectedPage(value) {
      if (value) {
        this.input.name = value.page_name
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/PageManagement/PageManage.vue